import React, { useRef } from "react";
import PropTypes from "prop-types";
import Button from "components/CustomButtons/Button.js";


export default function ImageUpload(props) {
  
  const [file, setFile] = React.useState(props.fileValue);
  const [imagePreviewUrl, setImagePreviewUrl] = React.useState(
    props.imagePreviewUrlValue
  );
  let fileInput= useRef(null);
  const handleSubmit = (e) => {
    let data = { file, imagePreviewUrl };
    console.log(file, imagePreviewUrl);
    return data;
  };
  const handleClick = () => {
    fileInput.current.click();
  };

  let {
    avatar,
    addButtonProps,
    changeButtonProps,
    removeButtonProps,
    handleImageChange,
    handleRemove,
    fileValue,
    imagePreviewUrlValue,
    viewMode,
  } = props;
  return (
    <div className="fileinput text-center" style={{ margin: "0 auto"}}>
      <input type="file" onChange={handleImageChange} ref={fileInput} />
      <div className={"thumbnail" + (avatar ? " img-circle" : "")} style={{width:"150px" , maxWidth: "250px", height: "auto", aspectRatio: "1", margin: "0 auto 10px"}}>
        <img src={imagePreviewUrlValue} alt="..." />
      </div>
      {!viewMode && ( // Only show buttons in edit mode
        <div style={{ textAlign: "center", margin:"0 auto 10px" }}>
          {fileValue === null ? (
            <Button {...addButtonProps} onClick={() => handleClick()}>
              {avatar ? "Add Photo" : "Select image"}
            </Button>
          ) : (
            <span>
              <Button {...changeButtonProps} onClick={() => handleClick()}>
                Change
              </Button>
              {avatar ? <br /> : null}
              <Button {...removeButtonProps} onClick={() => handleRemove()}>
                Remove
              </Button>
            </span>
          )}
        </div>
      )}
    </div>
  );
}

ImageUpload.propTypes = {
  avatar: PropTypes.bool,
  addButtonProps: PropTypes.object,
  changeButtonProps: PropTypes.object,
  removeButtonProps: PropTypes.object,
  handleSubmit: PropTypes.func,
  imagePreviewUrlValue: PropTypes.any,
  fileValue: PropTypes.any,
  viewMode: PropTypes.bool,
};
